import { ResultStatus } from "./resultStatus";
import { NoiseCatalogDataParams } from "./noiseCatalogDataParams";

export class NoiseCatalogParamsRefDataResponse {
    // series: Series[];
    // channel:Channel[];
    noiseCatalogDataParams?: NoiseCatalogDataParams;
    status?: ResultStatus;
}
